import { UIManager } from './ui/UIManager';

const uiRoot = document.querySelector<HTMLElement>('#ui-root');
const touchRoot = document.querySelector<HTMLElement>('#touch-controls');
if (!uiRoot || !touchRoot) throw new Error('Game UI roots are missing.');

export const uiManager = new UIManager(uiRoot, touchRoot);
